import { render, staticRenderFns } from "./UpdateAddManual.vue?vue&type=template&id=f50aca4e"
import script from "./UpdateAddManual.vue?vue&type=script&lang=js"
export * from "./UpdateAddManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports